import React, { useState, useEffect } from 'react';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js';
import { Route } from 'react-router-dom';
import Navbar from './Components/Navbar';
import Home from './Components/Home';
import About from './Components/About';
import Skill from './Components/Skill';
import Project from './Components/Project';
import Contact from './Components/Contact';
import Loader from './Components/Loader';
import Footer from './Components/Footer';
import { Switch } from 'react-router-dom';
import { Redirect } from 'react-router-dom';

const App = () => {
  const [loading,setLoading]=useState(false);
    useEffect(()=>{
        setLoading(true);
        setTimeout(()=>{
            setLoading(false)
        },4000)
    },[])
    return (
        loading?
        <Loader/>
        :
        <>
          
           <Navbar/>
             <Switch>
             <Route exact path="/" component={Home} />
             <Route exact path="/about" component={About} />
             <Route exact path="/skill" component={Skill} />
             <Route exact path="/project" component={Project} />
             <Route exact path="/contact" component={Contact} />
             <Redirect to="/"/>
             </Switch>
             <Footer/>
         
       
        </>
  )
}

export default App

